module.exports = __webpack_public_path__ + "img/Goin_7.39c245f9.jpg";